import insuranceRelationships from '@data/insuranceRealtionships';
import { commonErrors } from '@utils/error';
import { exists } from '@utils/general';
import { checkbox } from '@utils/validation';
import { DateTime } from 'luxon';
import { find, propEq } from 'ramda';
import { z } from 'zod';

export const memberSchema = z.object({
	insuredMemberFirstName: z.string().nonempty(),
	insuredMemberLastName: z.string().nonempty(),
	memberInsuranceId: z.string().min(3),
	rxGroup: z.string().optional(),
});

export const policyholderSchema = z.object({
	policyholderDob: z
		.string()
		.refine((date) => (date ? DateTime.fromISO(date).isValid : false), 'Enter a valid birth date'),
	policyholderFirstName: z.string().nonempty(),
	policyholderLastName: z.string().nonempty(),
	relationship: z
		.string()
		.refine(
			(relationship) => exists(find(propEq('value', relationship))(insuranceRelationships)),
			commonErrors.selectionRequired
		),
	notPolicyHolder: checkbox,
});
